<template>
    <div class="qa-drawer-select-templates">
        <div class="qa-drawer-select-templates__container">
            <div class="qa-drawer-select-templates__body">
                <CheckboxGroup :model-value="visibleMasterTemplateIds" @onChange="emitUpdatedVisibleMasterTemplateIds">
                    <Checkbox v-for="{ label, value } in options" :key="value" :label="value">
                        {{ label }}
                    </Checkbox>
                </CheckboxGroup>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { CampaignGetters, type Getters } from "@/store/modules/campaign";
import type { PropType } from "vue";

export default {
    props: {
        visibleMasterTemplateIds: {
            required: true,
            type: Array as PropType<string[]>
        }
    },

    emits: ["select"],

    computed: {
        options() {
            const masterTemplateLabels = this.$store.getters[
                CampaignGetters.masterTemplateLabels
            ] as Getters["masterTemplateLabels"];

            return Object.keys(masterTemplateLabels).map(masterTemplateId => ({
                label: masterTemplateLabels[masterTemplateId],
                value: masterTemplateId
            }));
        }
    },

    methods: {
        emitUpdatedVisibleMasterTemplateIds(visibleMasterTemplateIds: string[]) {
            this.$emit("select", visibleMasterTemplateIds);
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.qa-drawer-select-templates {
    display: inline-block;
    margin-left: $spacing-smaller;

    .ivu-checkbox-wrapper {
        display: block;
        margin: 0;
        padding: $spacing-small $spacing $spacing-small $spacing-smallest;
    }

    .ivu-dropdown-item {
        padding: 0;
    }
}

.qa-drawer-select-templates__container {
    display: flex;
    flex-direction: column;
}

.qa-drawer-select-templates__body {
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: auto;
}
</style>
